<template>
  <div class="contest-page-wrapper">
    <div class="container">
      <button class="button-primary mb-10 mr-10" @click="newContest">Create</button>
      <div class="contests-page-container">
        <div class="contests-main-content">
          <div class="card w-100">
            <div class="contests-header">
              <h3>Ongoing Contests</h3>
              <select class="org-filter input" v-model="filtered">
                <option :value="false">All contests</option>
                <option :value="true">In my organization</option>
              </select>
            </div>
            <div class="contests-display">
              <ContestBox v-if="filtered" v-for="entry in currentFiltered" :id="entry.contest.id"
                          :name="entry.contest.name"
                          :description="entry.contest.description" :creator_id="entry.contest.creator_id"
                          :start="entry.contest.start_date" :end="entry.contest.end_date"
                          :submissions="entry.submissions"
                          :votes="entry.votes"/>
              <ContestBox v-else v-for="entry in current" :id="entry.contest.id" :name="entry.contest.name"
                          :description="entry.contest.description" :creator_id="entry.contest.creator_id"
                          :start="entry.contest.start_date" :end="entry.contest.end_date"
                          :submissions="entry.submissions"
                          :votes="entry.votes"/>
            </div>
            <div class="separator"></div>
            <h3>Past contests</h3>
            <div class="contests-display">
              <ContestBox v-if="filtered" v-for="entry in recentFiltered" :id="entry.contest.id"
                          :name="entry.contest.name"
                          :description="entry.contest.description" :creator_id="entry.contest.creator_id"
                          :start="entry.contest.start_date" :end="entry.contest.end_date"
                          :submissions="entry.submissions"
                          :votes="entry.votes"/>
              <ContestBox v-else v-for="entry in recent" :id="entry.contest.id" :name="entry.contest.name"
                          :description="entry.contest.description" :creator_id="entry.contest.creator_id"
                          :start="entry.contest.start_date" :end="entry.contest.end_date"
                          :submissions="entry.submissions"
                          :votes="entry.votes"/>
            </div>
          </div>
        </div>
        <div class="contests-sidebar">
          <div class="card w-100">
            <h3>Coming up</h3>
            <div v-if="upcoming && filtered" v-for="contest in upcomingFiltered" class="future-contest-container my-10">
              <h3 class="future-contest-title">{{ contest.contest.name }}</h3>
              <p class="future-contest-start">Starting {{ formatDateUS(contest.contest.start_date) }}</p>
            </div>
            <div v-if="upcoming && !filtered" v-for="contest in upcoming" class="future-contest-container my-10">
              <h3 class="future-contest-title">{{ contest.contest.name }}</h3>
              <p class="future-contest-start">Starting {{ formatDateUS(contest.contest.start_date) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import apiService from '@/services/apiService';
import {onMounted, ref} from 'vue';
import {useRouter} from 'vue-router';
import ContestBox from '../common/ContestBox.vue';
import {filterContests, splitContests} from '@/util/contestUtil';
import {formatDateUS} from '@/util/dateUtil';

const router = useRouter();

const current = ref([]);
const recent = ref([]);
const upcoming = ref([]);

const filtered = ref(false);

const currentFiltered = ref([])
const recentFiltered = ref([])
const upcomingFiltered = ref([])

onMounted(async () => {
  const curr_res = await apiService.getCurrentContests();
  // Convert date strings to Date objects
  curr_res.forEach(c => {
    c.contest.start_date = new Date(c.contest.start_date);
    c.contest.end_date = new Date(c.contest.end_date);
  });

  const split = splitContests(curr_res);

  current.value = split.ongoing;
  upcoming.value = split.upcoming;

  const rec_res = await apiService.getRecentContests();
  rec_res.forEach(c => {
    c.contest.start_date = new Date(c.contest.start_date);
    c.contest.end_date = new Date(c.contest.end_date);
  });
  recent.value = rec_res;

  console.log("user org id", getUserOrgId())
  currentFiltered.value = filterContests(current.value, getUserOrgId())
  recentFiltered.value = filterContests(recentFiltered.value, getUserOrgId())
  upcomingFiltered.value = filterContests(upcomingFiltered.value, getUserOrgId())
});

function getUserOrgId() {
  return localStorage.getItem('org_id');
}


function newContest() {
  router.push('/contests/create');
}
</script>

<style scoped>
.contest-page-wrapper {
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  color: #323232;
}

.contests-page-container {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: start;
  justify-content: start;
}

.contests-main-content {
  width: 70%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-right: 1rem;
}

.contests-sidebar {
  width: 30%;
}

.contests-display {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  justify-content: start;
  gap: 1rem;
}

.contests-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.separator {
  border: 1px solid lightgray;
  margin: 2rem 0;
}

.future-contest-container {
  border: 1px solid lightgray;
  border-radius: 10px;
  padding: 0.5rem;
}

.future-contest-title {
  margin: 0;
}

.future-contest-start {
  margin: 0.5rem 0 0 0;
}

.org-filter {
  max-height: 2rem;
  background-color: white;
}
</style>